import React from "react";
import Avatar from "../../../../components/Avatar";
import { hasImage } from "../../../../utils";
import NotAssignCardIcon from "../../../../styles/svg/unassigned.svg";

const AvatarDisplay = ({ tooltipName, cardData, name, handleAvatarClick }) => {
  function getInitials(name) {
    const words = name?.trim()?.split(" ");

    const initials = words?.map((word) => word[0]?.toUpperCase())?.join("");

    return initials;
  }

  return (
    <div onClick={handleAvatarClick}>
      {cardData?.assigned_to_user_id ? (
        <Avatar
          title={tooltipName}
          className={"card-avtar header-avatar"}
          user_image={cardData?.assigned_to_user?.user_image}
          style={
            !hasImage(cardData?.assigned_to_user?.user_image) && {
              bgcolor: cardData?.assigned_to_user?.profile_color?.background,
              color: cardData?.assigned_to_user?.profile_color?.text,
            }
          }>
          {getInitials(name)}
        </Avatar>
      ) : (
        <Avatar
          unassigned={true}
          title={"Unassigned"}
          className={"card-avtar header-avatar"}
          user_image={NotAssignCardIcon}
        />
      )}
    </div>
  );
};

export default AvatarDisplay;
